import { render, staticRenderFns } from "./blok-text.vue?vue&type=template&id=078cef55&scoped=true&"
import script from "./blok-text.vue?vue&type=script&lang=js&"
export * from "./blok-text.vue?vue&type=script&lang=js&"
import style0 from "./blok-text.vue?vue&type=style&index=0&id=078cef55&lang=scss&scoped=true&"
import style1 from "./blok-text.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078cef55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078cef55')) {
      api.createRecord('078cef55', component.options)
    } else {
      api.reload('078cef55', component.options)
    }
    module.hot.accept("./blok-text.vue?vue&type=template&id=078cef55&scoped=true&", function () {
      api.rerender('078cef55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-text.vue"
export default component.exports